import * as React from 'react'

import { EmbroideryIconAsset } from '../../../../../types/graphql'
import {
  ScrollableItemsContent,
  ScrollableItemsScrollableArea,
  ScrollableItemsWrapper,
} from '../../shared-form-styles'

import { IconButton, StyledResponsiveImage } from './styles'

export const IconSelector: React.FC<{
  errorMessage?: string
  images: ReadonlyArray<EmbroideryIconAsset>
  labelId: string
  maxIconsPerRowMobile?: number | undefined
  onSelectIcon(iconImage: EmbroideryIconAsset): void
  productColorHex: string | undefined
  selectedImage: EmbroideryIconAsset | undefined
}> = ({
  images,
  labelId,
  maxIconsPerRowMobile,
  onSelectIcon,
  selectedImage,
  productColorHex: backgroundColor,
}) => {
  const imagesChunked = images.reduce<EmbroideryIconAsset[][]>((acc, curr, idx) => {
    // If maxIconsPerRowMobile is undefined, we display all icons in a single row
    const chunkIdx = Math.floor(idx / (maxIconsPerRowMobile ?? images.length))
    acc[chunkIdx] ||= []
    acc[chunkIdx]?.push(curr)

    return acc
  }, [])
  var imageIdx = -1

  return (
    <>
      <ScrollableItemsWrapper>
        <ScrollableItemsScrollableArea>
          <ScrollableItemsContent aria-labelledby={labelId} role='radiogroup'>
            {imagesChunked.map((imgs, index) => {
              const iconRow = imgs.map(image => {
                const isSelected: boolean = selectedImage === image
                imageIdx += 1

                return (
                  <IconButton
                    aria-checked={isSelected}
                    name='iconImage'
                    isSelected={isSelected}
                    key={imageIdx}
                    onClick={() => onSelectIcon(image)}
                    role='radio'
                    type='button'
                  >
                    <StyledResponsiveImage
                      {...{ backgroundColor }}
                      alt={image.caption || 'Embroidery Icon'}
                      src={image.source}
                      widths={{ unit: 'px', sm: 50, md: 60 }}
                      aspectRatios={{ sm: 1, md: 1 }}
                      loading='default'
                      key={image.id}
                    />
                  </IconButton>
                )
              })

              return (
                <div key={`icon-row-${index}`}>
                  {iconRow}
                  <hr />
                </div>
              )
            })}
          </ScrollableItemsContent>
        </ScrollableItemsScrollableArea>
      </ScrollableItemsWrapper>
    </>
  )
}
